module.exports = __webpack_public_path__ + "static/media/cow-mooing.efe82786.gif";